module.exports = __webpack_public_path__ + "static/media/completed-icon.f491f679.svg";